// extracted by mini-css-extract-plugin
export default {"container":"DataGridWithPagination_container__Gnrut","blessedWithContainer":"DataGridWithPagination_blessedWithContainer__C3j5i"};